export const MERL = 'Merl';
export const SITE_KEY = '6LcDyGMdAAAAAJGjoriFBlK0SPFY46-EUawTXkbs';
